{
  "version": 1,
  "asset_id": "c401e779-4266-4b6e-af84-3fec1759946e",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/c401e779-4266-4b6e-af84-3fec1759946e/home-hero-v2-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/c401e779-4266-4b6e-af84-3fec1759946e/home-hero-v2-640.avif",
  "original_filename": "home-hero-v2-640.avif",
  "size": 4759,
  "content_type": "image/avif",
  "created_at": "2026-10-10T12:40:07Z"
}
